import React, { FC, useContext } from "react";
import { useMedia } from "react-use";

import { useFeatureFlags } from "@/components/FeatureFlags";
import { UserContext } from "@/components/User";
import { MEDIA_SIZE_SM } from "@/core/media";
import { FEATURE_FLAG } from "@/data/feature-flags";
import { Flex } from "@/eworkitComponents";
import { router } from "@/views/router";

import { ContextDropdown } from "../../Navigation/ContextDropdown";
import { ChatRouteNavItem } from "../ChatRouteNavItem";
import { NotificationsRouteNavItem } from "../NotificationsRouteNavItem";
import { TasksNavItem } from "./TasksNavItem";

interface IAuthenticatedProps {}

export const Authenticated: FC<IAuthenticatedProps> = React.memo(() => {
  const { contextConsultantProfileId, contextCompany, hasCompanyManagerPrivileges, hasRouteAccess } =
    useContext(UserContext);
  const { isFeatureEnabled } = useFeatureFlags();

  const tasksRoute = router.get("tasks");

  const isSmallScreen = useMedia(MEDIA_SIZE_SM);

  if (!contextConsultantProfileId) {
    return null;
  }

  return (
    <Flex
      direction="row"
      align="center"
      justify="flex-end"
      innerMargin={isSmallScreen ? undefined : "xs"}
      padding={isSmallScreen ? [false, "sm"] : undefined}>
      {!isSmallScreen && hasRouteAccess(tasksRoute) && <TasksNavItem />}
      {!isSmallScreen &&
        isFeatureEnabled(FEATURE_FLAG.MESSAGE_CENTER) &&
        (!contextCompany || hasCompanyManagerPrivileges()) && <ChatRouteNavItem />}
      {!isSmallScreen && <NotificationsRouteNavItem />}
      <ContextDropdown />
    </Flex>
  );
});
